import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import {receivableChartOption} from "../../Data/Charts";
import "echarts-gl";
class ReceivablesDataChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.receivablesChartData !== this.props.receivablesChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { receivablesChartData } = this.props;
    if (receivablesChartData.length === 0) return [];

    const months = receivablesChartData.map(item => `${item.month} ${item.year}`);
    const receivableAmounts = receivablesChartData.map(item => item.total_amount || 0);
    const collectedAmounts = receivablesChartData.map(item => item.total_collected_amount || 0);
    return {
      months,
      receivableAmounts,
      collectedAmounts
    };
  };
  render() {

    const chartData = this.chartPlace();

    const option = receivableChartOption(chartData);

    return (
       <ReactEcharts option={option}>
         opts={{ renderer: 'svg' }}
         style={{ height: '400px', width: '100%' }}
       </ReactEcharts>

    );
  }
}

const mapStateToProps = (state) => ({
  receivablesChartData: state.analyticalReducer.receivablesChartData
});

export default connect(mapStateToProps, {})(ReceivablesDataChart);
